import createCustomStore from './create-custom-store';

export default vue => ({
  dataSource: createCustomStore('tracking/api/freight_orders/'),
  valueExpr: 'id',
  displayExpr(item) {
    if (!item) {
      return '';
    }
    return `N${item.id} ${item.company_name || vue.$t('no company')} (${item.consignor || ''}-${item.consignee || ''})`;
  },
});
